"use client";

import { createContext, useMemo, FC, PropsWithChildren, useState } from "react";

export interface IUIStateContext {
    setSiteHeaderHeight: (val: number) => void;
    setIsNotFoundPage: (val: boolean) => void;
    isNotFoundPage: boolean;
    siteHeaderHeight: number;
}

export const UIStateContext = createContext<IUIStateContext>(null as any);

export const UIStateProvider: FC<PropsWithChildren> = ({ children }) => {
    const [isNotFoundPage, setIsNotFoundPage] = useState(false);
    const [siteHeaderHeight, setSiteHeaderHeight] = useState(0);

    const value = useMemo(
        () => ({
            siteHeaderHeight,
            setSiteHeaderHeight,
            setIsNotFoundPage,
            isNotFoundPage,
        }),
        [siteHeaderHeight, isNotFoundPage],
    );

    return <UIStateContext.Provider value={value}>{children}</UIStateContext.Provider>;
};
